export enum MeasurementName {
    // APP
    LanguageNotSupported = 'FE.ACTIVITIES.LANGUAGE_NOT_SUPPORTED',
    MosaicCarouselLoaded = 'FE.ACTIVITIES.MOSAIC_CAROUSEL_LOADED',
    NavigateBookingFormFallback = 'FE.ACTIVITIES.NAVIGATE_BOOKING_FORM_FALLBACK',

    GqlTotal = 'FE.ACTIVITIES.GQL.TOTAL',
    GqlRetry = 'FE.ACTIVITIES.GQL.RETRY',
    GqlError = 'FE.ACTIVITIES.GQL.ERROR.GRAPHQL',
    GqlIncomplete = 'FE.ACTIVITIES.GQL.INCOMPLETE_RESPONSE',
    GqlNetworkError = 'FE.ACTIVITIES.GQL.ERROR.NETWORK',
    GqlRtt = 'FE.ACTIVITIES.GQL.RTT',

    // Text search
    ApiTextSearchStatus = 'FE.ACTIVITIES.API.TEXT_SEARCH.STATUS',
    ApiTextSearchNoResult = 'FE.ACTIVITIES.API.TEXT_SEARCH.NO_RESULTS',
    ApiTextSearchSuccess = 'FE.ACTIVITIES.API.TEXT_SEARCH.SUCCESS',
    ApiTextSearchError = 'FE.ACTIVITIES.API.TEXT_SEARCH.ERROR',
    ApiTopDestinationNoResult = 'FE.ACTIVITIES.API.TOP_DESTINATION.NO_RESULTS',
    ApiTopDestinationSuccess = 'FE.ACTIVITIES.API.TOP_DESTINATION.SUCCESS',
    ApiTopDestinationError = 'FE.ACTIVITIES.API.TOP_DESTINATION.ERROR',

    // Translation
    ApiTranslationStatus = 'FE.ACTIVITIES.API.TRANSLATION.STATUS',
    ApiTranslationNoResult = 'FE.ACTIVITIES.API.TRANSLATION.NO_RESULTS',
    ApiTranslationSuccess = 'FE.ACTIVITIES.API.TRANSLATION.SUCCESS',
    ApiTranslationError = 'FE.ACTIVITIES.API.TRANSLATION.ERROR',

    // Availability
    GqlAvailabilityStatus = 'FE.ACTIVITIES.GQL.AVAILABILITY.STATUS',
    GqlAvailabilityNoOffer = 'FE.ACTIVITIES.GQL.AVAILABILITY.NO_OFFERS',
    GqlAvailabilityOnlyUnavailableOffer = 'FE.ACTIVITIES.GQL.AVAILABILITY.ONLY_UNAVAILABLE_OFFERS',
    GqlAvailabilityAvailableOffer = 'FE.ACTIVITIES.GQL.AVAILABILITY.AVAILABLE_OFFERS',
    GqlAvailabilitySuccess = 'FE.ACTIVITIES.GQL.AVAILABILITY.SUCCESS',
    GqlAvailabilityError = 'FE.ACTIVITIES.GQL.AVAILABILITY.ERROR',
    AvailabilityOffersComparison = 'FE.ACTIVITIES.GQL.AVAILABILITY.OFFERS.COMPARISON',

    // Calendar
    GqlCalendarStatus = 'FE.ACTIVITIES.GQL.CALENDAR.STATUS',
    GqlCalendarSuccess = 'FE.ACTIVITIES.GQL.CALENDAR.SUCCESS',
    GqlCalendarError = 'FE.ACTIVITIES.GQL.CALENDAR.ERROR',
    GqlCalendarNoSchedule = 'FE.ACTIVITIES.GQL.CALENDAR.NO_SCHEDULES',
    GqlCalendarScheduleMismatch = 'FE.ACTIVITIES.GQL.CALENDAR.SCHEDULES_MISMATCH',

    // Review
    GqlReviewStatus = 'FE.ACTIVITIES.GQL.REVIEW.STATUS',
    GqlReviewSuccess = 'FE.ACTIVITIES.GQL.REVIEW.SUCCESS',
    GqlReviewError = 'FE.ACTIVITIES.GQL.REVIEW.ERROR',
    GqlReviewNoReview = 'FE.ACTIVITIES.GQL.REVIEW.NO_REVIEWS',
    GqlReviewActivityNotFound = 'FE.ACTIVITIES.GQL.REVIEW.ACTIVITY_NOT_FOUND',

    // Landing Link
    LandingLinkApiStatus = 'FE.ACTIVITIES.LANDING_LINK_SERVICE.STATUS',
    LandingLinkApiSuccess = 'FE.ACTIVITIES.LANDING_LINK_SERVICE.SUCCESS',
    LandingLinkApiError = 'FE.ACTIVITIES.LANDING_LINK_SERVICE.ERROR',
    LandingLinkApiNoResult = 'FE.ACTIVITIES.LANDING_LINK_SERVICE.NO_RESULTS',

    // Search
    GqlSearchStatus = 'FE.ACTIVITIES.GQL.SEARCH.STATUS',
    GqlSearchSuccess = 'FE.ACTIVITIES.GQL.SEARCH.SUCCESS',
    GqlSearchError = 'FE.ACTIVITIES.GQL.SEARCH.ERROR',
    GqlSearchAapiNoResult = 'FE.ACTIVITIES.GQL.SEARCH.NO_RESULTS_FROM_AAPI',

    // City
    ApiTopCitiesNoResult = 'FE.ACTIVITIES.API.TOP_CITIES.NO_RESULTS',
    ApiTopCitiesSuccess = 'FE.ACTIVITIES.API.TOP_CITIES.SUCCESS',
    ApiTopCitiesError = 'FE.ACTIVITIES.API.TOP_CITIES.ERROR',
    ApiCityContentNoResult = 'FE.ACTIVITIES.API.CITY_CONTENT.NO_RESULTS',
    ApiCityContentSuccess = 'FE.ACTIVITIES.API.CITY_CONTENT.SUCCESS',
    ApiCityContentError = 'FE.ACTIVITIES.API.CITY_CONTENT.ERROR',

    // Detail
    GqlDetailStatus = 'FE.ACTIVITIES.GQL.DETAIL.STATUS',
    GqlDetailSuccess = 'FE.ACTIVITIES.GQL.DETAIL.SUCCESS',
    GqlDetailError = 'FE.ACTIVITIES.GQL.DETAIL.ERROR',
    PageVisit = 'FE.ACTIVITIES.PAGE.VISIT',

    // Session Package
    SessionPackageInitialized = 'ul.sdk.session.moduleload',
    SessionForceLogout = 'ul.sdk.session.forcelogout',
    SessionRefreshtoken = 'ul.sdk.session.refreshtoken',

    // City By Geo Radius
    CityGeoRadiusStatus = 'FE.ACTIVITIES.API.CITYGEORADIUS.STATUS', // todo: ACT-4049 - add tracking for near me feature
    CityGeoRadiusNoResult = 'FE.ACTIVITIES.API.CITYGEORADIUS.NO_RESULTS',
    CityGeoRadiusSuccess = 'FE.ACTIVITIES.API.CITYGEORADIUS.SUCCESS',
    CityGeoRadiusError = 'FE.ACTIVITIES.API.CITYGEORADIUS.ERROR',

    // Image loading failure
    ImageLoadingFailure = 'FE.ACTIVITIES.IMAGE_LOADING.FAILURE',

    // Cusco Campaigns

    CuscoCampaignsStatus = 'FE.ACTIVITIES.CUSCO_CAMPAIGNS.STATUS',
    CuscoCampaignsError = 'FE.ACTIVITIES.CUSCO_CAMPAIGNS.ERROR',
    CuscoCampaignsSuccess = 'FE.ACTIVITIES.CUSCO_CAMPAIGNS.SUCCESS',
    CuscoCampaignsNoResults = 'FE.ACTIVITIES.CUSCO_CAMPAIGNS.NO_RESULTS',
}
